import { IUniversalIdentifier } from '../../common'

export interface AutoRenewal {
  is_active: boolean
  days_before_cancellation: number
  days_before_email: number
}

export interface Membership extends IUniversalIdentifier {
  autorenewal: AutoRenewal
  name: string
  code: string
  version: number
  channels: string[]
  total: number
  total_monthly: number
  is_active: boolean
  is_git_sync: boolean
  public: boolean
  play_right_only: boolean
  state: string
  fees: Fee[]
  duration: Duration
  description: string
  membership_requirements: MembershipRequirements[]
  membership_member_limit: MembershipMemberLimit
  membership_age_range_limit: MembershipAgeRangeLimit
  id: number
  uuid: string
  is_sell_membership_enabled: boolean
  is_git_club_selectable: boolean
  type: SubscriptionType
}
export interface MembershipCardPayment {
  amount: {
    value: number
    currency: string
  }
  state: string
  type: string
  paid_at: string
  id: number
  uuid: string
}

export type Fee = {
  id: number
  monthly_price: number
  price: number
  uuid: string
  vat: number
  fee_unit: FeeUnit
}

export type FeeUnit = {
  id: number
  uuid: string
  name: string
}

export type Duration = {
  options: string[]
  from: string
  to: string
}

export type MembershipRequirements = {
  type: string
  configuration: ConfigurationSetting
}

export type MembershipMemberLimit = {
  is_active: boolean
  current_members: number
  fully_booked: boolean
  max_members: number
}

export type MembershipAgeRangeLimit = {
  min: number
  max: number
}

export type ConfigurationSetting = {
  setting: boolean
}

export enum MembershipCardPaymentSource {
  ONSITE = 'onsite',
  ONLINE = 'online',
  GIT = 'git',
}

export enum SubscriptionType {
  MEMBERSHIP = 'membership',
  PASS = 'pass',
}

export enum SubscriptionTypes {
  MEMBERSHIPS = 'memberships',
  PASSES = 'passes',
}

export interface MembershipCard extends IUniversalIdentifier {
  /** Name of the membership card*/
  name: string
  is_locked: boolean
  is_paid: boolean
  status: string
  state: string
  membership: Membership
  order?: { token: number }
  payment_source?: MembershipCardPaymentSource
  starts_at: string
  expires_at: string
}

export interface MembershipItem extends IUniversalIdentifier {
  name: string
  type: string
  status: {
    text: string
    state: string
  }
  state: string
  gitSync: string
  playerRights: string
  price: number
  playerFee: number
  extraFee: number
  totalPrice: number
  totalMonthly: number
  totalPriceFormatted: string
  totalMonthlyFormatted: string
  public: string
  duration: string[]
  duration_original: string[]
}
